// extracted by css-extract-rspack-plugin
export default {"cls1":"MentionsCardHeader-cls1_t7t","cls2":"MentionsCardHeader-cls2_Frd MentionsCardHeader-cls1_t7t"};